import { render, staticRenderFns } from "./PropertiesForRent.vue?vue&type=template&id=5ab5963c&"
import script from "./PropertiesForRent.vue?vue&type=script&lang=ts&"
export * from "./PropertiesForRent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports